import { render, staticRenderFns } from "./PeriodoIndicador.vue?vue&type=template&id=2a022cde&scoped=true"
import script from "./PeriodoIndicador.vue?vue&type=script&lang=js"
export * from "./PeriodoIndicador.vue?vue&type=script&lang=js"
import style0 from "./PeriodoIndicador.vue?vue&type=style&index=0&id=2a022cde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a022cde",
  null
  
)

export default component.exports